"use client";
"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MobileShareMenu = exports.MobileSharePanel = void 0;
const react_1 = __importDefault(require("react"));
const foundations_1 = require("../../foundations");
const useAvoidIsMobile_1 = require("../../hooks/useAvoidIsMobile");
const Button_1 = require("../Button");
const Divider_1 = require("../Divider");
const Modal_1 = require("../Modal");
const MobileSharePanel = ({ visible, onDismiss, shareItems }) => {
    const sharedSx = {
        color: "text01",
        display: "flex",
        gap: 4,
        alignItems: "center",
        textDecorationColor: "text01",
        ":hover": {
            textDecoration: "underline",
            cursor: "pointer"
        }
    };
    return (react_1.default.createElement(Modal_1.Modal, { isOpen: visible, onDismiss: onDismiss },
        react_1.default.createElement(foundations_1.Box, { "data-testid": "share-menu-panel", sx: { display: "flex", flexDirection: "column", gap: 4, p: 5 } },
            react_1.default.createElement(foundations_1.Box, { sx: {
                    alignItems: "center",
                    display: "flex",
                    justifyContent: "space-between"
                } },
                react_1.default.createElement(foundations_1.Text, { as: "h3", size: "2xl", variant: "bold" }, "Share")),
            shareItems.map((item, index) => (react_1.default.createElement(react_1.default.Fragment, { key: index },
                index !== 0 && react_1.default.createElement(Divider_1.Divider, null),
                react_1.default.createElement(foundations_1.Box, { sx: {
                        display: "flex"
                    } },
                    react_1.default.createElement(foundations_1.Box, { as: "button", "aria-label": item.ariaLabel, sx: sharedSx, onClick: item.clickHandler, "data-testid": item.dataTestIdMobile },
                        react_1.default.createElement(foundations_1.Icon, { icon: item.icon, size: "base" }),
                        react_1.default.createElement(foundations_1.Text, { as: "p", size: "lg", variant: "bold" }, item.name)))))))));
};
exports.MobileSharePanel = MobileSharePanel;
const MobileShareMenu = ({ isShareMenuOpen, setIsShareMenuOpen, shareItems, buttonLabel, buttonVariant = "primary" }) => {
    const isMobileView = (0, useAvoidIsMobile_1.useAvoidIsMobile)();
    const onDismiss = () => {
        setIsShareMenuOpen(false);
    };
    return (react_1.default.createElement(foundations_1.Box, { sx: {
            display: ["flex", "none", "none"],
            height: [16, "auto", "auto"],
            alignItems: "center"
        }, "data-testid": "mobile-container" },
        react_1.default.createElement(Button_1.Button, { onClick: () => setIsShareMenuOpen(true), "data-testid": "share-button-mobile", variant: buttonVariant },
            buttonLabel,
            react_1.default.createElement(foundations_1.Icon, { icon: "share-fat" })),
        isMobileView ? (react_1.default.createElement(exports.MobileSharePanel, { visible: isShareMenuOpen, onDismiss: onDismiss, shareItems: shareItems })) : null));
};
exports.MobileShareMenu = MobileShareMenu;
//# sourceMappingURL=MobileShareMenu.js.map